import React, { useState, useEffect } from 'react';
import { ContainerRadio, ShowError } from './styles';
import { Icon } from '../../../../../../components';

interface RadioButtonProps {
  question: string;
  parenthesisText?: string;
  firstLabel: string;
  secondLabel: string;
  firstValue: string;
  secondValue: string;
  value: string;
  groupName: string;
  icon?: any;
  isLineText?: boolean;
  isQuestionBold?: boolean;
  children?: any;
  setFieldError: ({ name, value }: any) => void;
  setFieldValue: ({ name, value }: any) => void;
  validateOnStart?: boolean;
  validateForm: number;
  isRequired?: boolean;
}

const RadioButton: React.FC<RadioButtonProps> = (props) => {
  const {
    question,
    parenthesisText,
    firstLabel,
    secondLabel,
    firstValue,
    secondValue,
    value,
    groupName,
    icon,
    isLineText,
    isQuestionBold,
    children,
    setFieldError,
    setFieldValue,
    validateOnStart,
    validateForm,
    isRequired
  } = props;

  const [radioBtnSelected, setRadioBtnSelected] = useState(value || '');
  const [errorText, setErrorText] = useState('');
  const [disparadorFocus, setDisparadorFocus] = useState(true);

  const checkRadio = (e: any) => {
    setFieldValue({
      name: groupName,
      value: e.target.value
    });
    setErrorText('');
    setRadioBtnSelected(e.target.value);

    setFieldError({
      name: e.target.name,
      value: ![firstValue, secondValue].includes(e.target.value)
    });

    if (isLineText && e.target.value === secondValue) {
      children.props.setFieldValue({ name: children.props.name, value: '0' });
    } else if (isLineText && e.target.value === firstValue) {
      children.props.setFieldValue({ name: children.props.name, value: '' });
    }
  };

  useEffect(() => {
    if ((validateOnStart || validateForm > 0) && !value && isRequired) {
      setErrorText('Dato pendiente');
    }
  }, [validateOnStart, validateForm]);

  const handledisparadorFocus = () => {
    setDisparadorFocus(true);
    setTimeout(() => {
      setDisparadorFocus(false);
    }, 250);
  };

  return (
    <ContainerRadio isLineText={isLineText} data-testid="cmp-radio-button">
      <p className={`text ${isQuestionBold ? 'text-bold' : ''}`}>
        <img className={`img ${icon ? 'show' : ''}`} src={icon} alt="" />
        {question}
        {parenthesisText && (
          <span className="parenthesis"> {parenthesisText}</span>
        )}
      </p>
      <ShowError error={errorText}>
        {errorText && (
          <div className="errorText">
            <Icon name="alert-triangle" size={12} />
            {errorText}
          </div>
        )}
      </ShowError>
      <div className="orientationRadioButtons">
        <div style={{ display: 'flex' }}>
          <label className="text circle-label">
            <span />
            <input
              data-testid="radio-button-input"
              onChange={checkRadio}
              onClick={() => {
                setErrorText('');
                handledisparadorFocus();
              }}
              type="radio"
              id={firstLabel}
              checked={radioBtnSelected === firstValue}
              value={firstValue}
              name={groupName}
              className={disparadorFocus ? 'focus-class' : 'blur-class'}
            />
            <div className="circle circle1">
              <div
                className={`circle ${errorText ? 'circleError' : 'circle2'}`}
              >
                <div className="circle circle3" />
              </div>
            </div>
            {firstLabel}
          </label>
          {isLineText &&
            (radioBtnSelected === firstValue ? (
              <div>{React.cloneElement(children, { isDisabled: false })}</div>
            ) : (
              <div>
                {React.cloneElement(children, {
                  value: '',
                  isDisabled: true
                })}
              </div>
            ))}
        </div>
        <div style={{ display: 'flex' }}>
          <label className="text circle-label">
            <input
              onChange={checkRadio}
              onClick={() => {
                handledisparadorFocus();
              }}
              type="radio"
              id={secondLabel}
              checked={radioBtnSelected === secondValue}
              value={secondValue}
              name={groupName}
              className={disparadorFocus ? 'focus-class' : 'blur-class'}
            />
            <div className="circle circle1">
              <div
                className={`circle circle2 ${errorText ? 'circleError' : ''}`}
              >
                <div className="circle circle3" />
              </div>
            </div>
            {secondLabel}
          </label>
        </div>
      </div>

      {radioBtnSelected === firstValue && !isLineText && (
        <div>{children[0]}</div>
      )}
      {radioBtnSelected === secondValue && !isLineText && (
        <div>{children[1]}</div>
      )}
    </ContainerRadio>
  );
};
RadioButton.defaultProps = {
  children: <></>,
  isLineText: false,
  isQuestionBold: false
};

export default RadioButton;
